module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getBlockModifiers(),
    on: {
      "touchstart": _vm.down,
      "touchend": _vm.up,
      "touchcancel": _vm.leave,
      "touchmove": _vm.leave,
      "mousedown": _vm.down,
      "mouseup": _vm.up,
      "mouseleave": _vm.leave
    }
  }, [_c('div', {
    class: [_vm.block + '-inner']
  }, [(_vm.path) ? _c('router-link', {
    class: [_vm.block + '-route'],
    attrs: {
      "to": _vm.route
    }
  }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('icon-gb', {
    class: [_vm.block + '-icon'],
    attrs: {
      "name": 'spotin-com-' + _vm.icon
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16bd529b","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Button.vue
// module id = 407
// module chunks = 0